import { css } from "styled-components";

export const containerWidth = css`
  width: 1080px;
  max-width: 90%;
`;
